module.exports = __webpack_public_path__ + "static/media/April Zemyan Headshot.887c37fd.jpeg";